export interface PopupOrderState {
    order: PopupOrderItem[]
}

export type PopupType = "Eval" | "EvalStart" | "Webinar" | "Releases" | "RequestDirectBidding" | "RequestAllToAllBidding";

export enum PopupOrderStatus {
    Wait = "Wait",
    Shown = "Shown",
    Inactive = "Inactive",
}

export interface PopupOrderItem {
    popup: PopupType
    status: PopupOrderStatus
}